import { useTranslation } from 'react-i18next';
import { ErrMessageKeys, validateEmail, ValidationRules } from '@myme/utils';

export interface POSTResetPasswordReqBody {
  email: string;
}

export const useResetPasswordForm = () => {
  const { t } = useTranslation();

  const validationRules: ValidationRules = {
    email: { required: true, validate: value => validateEmail(value as string) }
  };
  const errorMessageKeys: ErrMessageKeys = {
    email: t('errors.validation.email_incorrect')
  };

  return {
    rules: validationRules,
    errMessage: errorMessageKeys
  };
};
